import React from 'react';
import * as XLSX from 'xlsx';
import DatePicker from 'react-datepicker';
import '../styles/react-datepicker.css';
import Cookies from "js-cookie";

// const FilterComponent = ({ filters, onFilterChange, onApplyFilters,data  }) => {
const FilterComponent = ({ filters,filtersState, handleFilterChange,data,hasExportPDF=true  }) => {


      // Export to Excel function
  const handleExportExcel = () => {
    if (!data || data.length === 0) return;

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, 'export.xlsx');
  };


const buildQueryParamsFromFilters = (filters) => {
  const params = new URLSearchParams();

  filters.forEach(f => {
    if (!f.value) return;

    if (f.type === "date_range") {
      if (Array.isArray(f.value) && f.value.length === 2) {
        params.append("date_created[]", f.value[0]);
        params.append("date_created[]", f.value[1]);
      }
    } else {
      params.append(f.field, f.value);
    }
  });

  return params.toString();
};



const handlEexportPDF = async (filters) => {
  const queryString = buildQueryParamsFromFilters(filters);

  const accessToken = Cookies.get("access_token");

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/export-pdf/?${queryString}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
      }
    }
  );

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = "notarial_register.pdf";
  link.click();
};





  const handlEexportPDF_old = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/export-pdf/`);
    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "notarial_register.pdf";
    link.click();
  };


  console.log("filters",filters);
  return (

        <div className="d-flex justify-content-start align-items-center">

        {filters.length > 0 && filters.map((filter, index) => (
            <div key={index} className="form-group me-4">
            <label>{filter.label}</label>
            {filter.type === 'text' && (
                <input
                type="text"
                className="form-control"
                value={filtersState[filter.field] || ''}
                placeholder={filter.placholder}
                
                onChange={(e) => handleFilterChange(filter.field, e.target.value)}
                />
            )}
            {filter.type === 'date' && (
                <input
                type="date"
                className="form-control"
                value={filtersState[filter.field] || ''}
                onChange={(e) => handleFilterChange(filter.field, e.target.value)}
                />
            )}

            {filter.type === 'date_range' && (
              <DatePicker
                selected={
                  filtersState[filter.field]?.[0]
                    ? new Date(`${filtersState[filter.field][0]}T00:00:00`)
                    : null
                }
                onChange={(dates) => handleFilterChange(filter.field, dates)}
                startDate={
                  filtersState[filter.field]?.[0]
                    ? new Date(`${filtersState[filter.field][0]}T00:00:00`)
                    : null
                }
                endDate={
                  filtersState[filter.field]?.[1]
                    ? new Date(`${filtersState[filter.field][1]}T00:00:00`)
                    : null
                }
                selectsRange
                dateFormat="yyyy-MM-dd"
                className="form-control"
                placeholderText="Select Date Range"
              />

            )}


             
             {/* Select filter */}
          {filter.type === 'select' && (
            <select
                className="form-control"
                value={filtersState[filter.field] || ''}
                onChange={(e) => handleFilterChange(filter.field, e.target.value)}
              >
                {filter.options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
          )}
            </div>
        ))}

        {/* <button className="btn btn-info h-100 mt-4" onClick={onApplyFilters}>
            Apply Filterss
        </button> */}

        {/* <button className="btn btn-success h-100 mt-4 ms-1" onClick={handleExportExcel}>
          Export Excel
        </button> */}
        {
          hasExportPDF && 
          <button className="btn btn-info h-100 mt-4 ms-1" onClick={() => handlEexportPDF(filters)}>
            Export PDF
          </button>
        }
      

 
        </div>
  
  );
};

export default FilterComponent;